var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 22,
    viewBox: "0 0 113 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 22H0V0H21.1875V22Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1406 22H22.9531V0H44.1406V22Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0938 22H45.9062V0H67.0938V22Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0469 22H68.8594V0H90.0469V22Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 22H102.406V0H113V22Z",
    fill: "#DCDCE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.406 22H91.8125V0H102.406V22Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5934 7.17448L13.8156 8.0224L15.1619 3.71406L10.5934 7.17448ZM18.009 12.7432H12.3369L10.5934 18.2891L8.8498 12.7432H3.17773L7.76836 9.30573L6.0248 3.7599L10.6154 7.1974L13.4404 9.30573L18.009 12.7432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5465 7.17448L36.7688 8.0224L38.115 3.71406L33.5465 7.17448ZM40.9621 12.7432H35.29L33.5465 18.2891L31.8029 12.7432H26.1309L30.7215 9.30573L28.9779 3.7599L33.5686 7.1974L36.3936 9.30573L40.9621 12.7432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4996 7.17448L59.7219 8.0224L61.0682 3.71406L56.4996 7.17448ZM63.9152 12.7432H58.2432L56.4996 18.2891L54.7561 12.7432H49.084L53.6746 9.30573L51.9311 3.7599L56.5217 7.1974L59.3467 9.30573L63.9152 12.7432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4527 7.17448L82.675 8.0224L84.0213 3.71406L79.4527 7.17448ZM86.8684 12.7432H81.1963L79.4527 18.2891L77.7092 12.7432H72.0371L76.6277 9.30573L74.8842 3.7599L79.4748 7.1974L82.2998 9.30573L86.8684 12.7432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.406 7.17448L105.628 8.0224L106.974 3.71406L102.406 7.17448ZM109.821 12.7432H104.149L102.406 18.2891L100.662 12.7432H94.9902L99.5809 9.30573L97.8373 3.7599L102.428 7.1974L105.253 9.30573L109.821 12.7432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 22,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStars);
export default __webpack_public_path__ + "static/media/green-stars.77671bd5bd33ef8799588ceefe15de41.svg";
export { ForwardRef as ReactComponent };